import Carousel from 'widgets/global/Carousel';
import { extend } from 'widgets/toolbox/util';

/**
 * @description product carousel implementation
 */
export default class ProductCarousel extends Carousel {
    prefs() {
        return {
            ...super.prefs()
        };
    }

    init() {
        super.init();
        this.eventBus().emit('product.listing.init', this);
        this.eventBus().on('modal.next', 'findAndClickNext');
    }

    initOptions() {
        super.initOptions();
        extend(this.options, JSON.parse(this.config.sitePreferences.GLOBAL_CAROUSEL_CONFIGURATION), this.prefs().carouselOptions || {});
    }

    findAndClickNext(pid){
        if(pid) {
            $(this.refs.slides.els[0]).find(".b-product-tile[data-pid="+pid+"]").click();
        }            
    }
}